<template>
  <div>
    <v-subheader class="title-setting">Etiquetas</v-subheader>

    <v-form @submit.prevent ref="form" v-model="valid" class="py-4 px-4" v-on:submit.prevent="save">
      <v-row>
        <v-col cols="12" md="6">
          <v-menu v-model="colorPickerMenu" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ props }">
              <v-text-field v-model="item.color_label" label="Color" hint="Color de fondo para cabeceras de impresión"
                persistent-hint readonly v-bind="props" :loading="loading_settings">
                 <template v-slot:prepend-inner>
                        <v-icon :style="{ color: item.color_label }">mdi-palette</v-icon>
                      </template>
                </v-text-field>
            </template>

            <v-card>
              <v-color-picker v-model="item.color_label" mode="hexa" show-swatches swatches-max-height="150" />
              <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="colorPickerMenu = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

        </v-col>



        <v-col cols="12" md="12" class="text-start">
          <div v-if="item.logo_label_url">
            <img :src="item.logo_label_url" style="object-fit: cover; max-width: 200px; max-height: 100px;background: rgba(0,0,0,0.5);
  padding: 15px;" alt="Logo actual" />
          </div>
          <div v-else>
            <v-avatar size="130">
              <v-img :src="require('@/assets/images/no-photo.png')" cover />
            </v-avatar>
          </div>
        </v-col>

        <v-col cols="12">
          <p class="caption">Tamaño recomendado 200x100px</p>
          <v-btn @click="uploadImage" color="primary" size="small">Adjuntar logo</v-btn>
          <v-file-input ref="image_ref" v-model="item.image_label" accept="image/*" style="display: none"
            @change="setImage" />
        </v-col>

        <v-col cols="12" class="text-right mt-4">
          <v-btn :loading="loading" color="success" type="submit">Guardar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  props: {
    mainItem: Object,
    createItem: Function,
    loading: Boolean,
    loading_settings: Boolean
  },
  mixins: [ValidMixin],
  watch: {
    mainItem: {
      handler(newVal) {
        this.item = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      item: JSON.parse(JSON.stringify(this.mainItem)), // copia profunda para evitar mutar la prop
      colorPickerMenu: false,

    };
  },
  methods: {
    uploadImage() {
      this.$refs.image_ref.$el.querySelector("input[type='file']").click();
    },
    setImage() {
      if (this.item.image_label) {
        this.item.logo_label_url = URL.createObjectURL(this.item.image_label);
      }
    },
    save(e) {
      if (this.valid) {
        this.$emit("createItem", e, this.item, 'labels');

      } else {
        console.log("Formulario no válido");
      }
    },
  },
};
</script>
